import React, { useContext } from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import classes from "./AddSong.module.css";
import Song from "../../../types/Song";
import SearchSong from "../../../components/SearchSong/SearchSong";
import { UserContext } from "../../../contexts/AuthContext";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Input from "../../../components/common/Input";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import { ToastContainer, toast } from 'react-toastify';
const apiUrl = process.env.REACT_APP_API_URL;

interface AddSongProps {
  songToEdit?: Song;
  onComplete?: () => void;
}


const AddSong: React.FC<AddSongProps> = ({songToEdit, onComplete}) => {
  const navigate = useNavigate();
  const [filteredSongs, setFilteredSongs] = useState<Song[]>([]);
  
  const [isDataFetching, setIsDataFetching] = useState<boolean>(false);

  const [text, setText] = useState<string>("");

  const [addNewToggle, setAddNewToogle] = useState(false);
  const context = useContext(UserContext);
  
  const searchSongByTitle = async (title: string)=> {
    try {
      if(title && title.length < 2) {
        setFilteredSongs([]);
        return
      };
      setIsDataFetching(true);
      const response = await fetch(`${apiUrl}/lyrics/admin/search?keyword=${title}`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${context.token}`,
          "Content-Type": "application/json"
        }   
      });
      const data: Song[] = await response.json();
      setFilteredSongs(data);
      setIsDataFetching(false);
    } catch(error) {
      setFilteredSongs([]);
      setIsDataFetching(false);
    }
  }

  const schema = yup.object().shape({
    lyrics: yup
    .string()
    .test("not-empty", "Lyrics are required", (value) => {
      return !!value && value.replace(/<[^>]+>/g, "").trim().length > 0;
    }),
    lyricist: yup.string().required("Lyricist is required"),
    credits: yup.string().required("Credits name is required"),
    englishTitle: yup.string().required("English title are required"),
    teluguTitle: yup.string().required("Telugu title are required"),
    status: yup.string().oneOf(["ACTIVE", "INACTIVE"], "Invalid status").required("Status is required"),
  });

  const {
    register,
    handleSubmit,
    control,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      status: "ACTIVE"
    }
  });

  useEffect(() => {
    if (songToEdit) {
      setValue("englishTitle", songToEdit.title.english);
      setValue("teluguTitle", songToEdit.title.telugu);
      setValue("lyricist", songToEdit?.lyricist?? "");
      setValue("credits", songToEdit.credits);
      setValue("status", songToEdit.status as "ACTIVE" | "INACTIVE");
      setText(songToEdit.lyrics || "");
      setValue("lyrics", songToEdit.lyrics || "");
    }
  }, [songToEdit]);

  const goToEditLyricsHandler = (item: Song)=> {
    navigate("/dashboard/edit-lyrics", { 
      state: { 
        songId: item.slug,
        from: "/dashboard/add-song"
      }
    });
  }

  const onSubmit = (data:any) => {
    console.log("Form Data:", data);
    // alert("Form submitted successfully!");
    const submitLyrics = async ()=> {
      const response = await fetch(`${apiUrl}/lyrics`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${context.token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          lyricist: data.lyricist,
          title: {
            telugu: data.teluguTitle,
            english: data.englishTitle
          },
          lyrics: data.lyrics,
          credits: data.credits,
          status: data.status
        })     
      });
      if(response.status === 201 ) {
        toast.success("Song created successfully");
        reset();
        setText("");
      } else {
        toast.error("Song creation failed!");
      }
    }
    submitLyrics();
  };

  return (
    <>
      
      <div className={classes.addSongWraper}>
        <ToastContainer></ToastContainer>
        {/* {!addNewToggle && (
          <>
            <button type="button" className={classes.submitButton} onClick={()=> {toast.error("Wow so easy!");setAddNewToogle(!addNewToggle)}}>
                Add New
            </button>
          </>
        )}  */}
        
          <div className="max-w-md mx-auto p-6 bg-white shadow-md rounded-lg">
              <h2 className="text-xl font-bold mb-4">Add new Lyric</h2>
              <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
                  <div className={classes.input}>
                    <Input type="text" label="English Title" {...register("englishTitle", {
                      onChange: (e) => {
                        //console.log("Value in parent:", e.target.value);
                        searchSongByTitle(e.target.value);
                      }
                    })} 
                    />

                    {errors.englishTitle && (
                      <p className={classes.formError}>{errors.englishTitle.message}</p>
                    )}
                  </div>
                  {filteredSongs.length >0 && filteredSongs.map((item, index) => {
                    return(<p key={item._id} onClick={()=> {
                      goToEditLyricsHandler(item)
                    }}>{item.title.telugu}</p>)
                  })}
                    <>
                    <div className={classes.input}>
                      <Input type="text" label="Telugu Title" {...register("teluguTitle")} />
                      {errors.teluguTitle && (
                        <p className={classes.formError}>{errors.teluguTitle.message}</p>
                      )}
                    </div>

                    <div className={classes.input}>
                        <Input type="text" label="Lyricist" {...register("lyricist")} />
                        {errors.lyricist && (
                          <p className={classes.formError}>{errors.lyricist.message}</p>
                        )}
                    </div>

                    <div className={classes.input}>
                        <Input type="text" label="Credits" {...register("credits")} />
                        {errors.credits && (
                          <p className={classes.formError}>{errors.credits.message}</p>
                        )}
                    </div>

                    <div className={classes.input}>
                      <Controller
                          name="lyrics"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <div>
                              <label className="block font-medium mb-1">Lyrics</label>
                              <ReactQuill
                                theme="snow"
                                value={text}
                                onChange={(value) => {
                                  setText(value);
                                  field.onChange(value); // Already HTML string
                                }}
                                style={{ minHeight: 300 }}
                                className={classes.richTextContainer}
                              />
                              {errors.lyrics && (
                                <p className={classes.formError}>{errors.lyrics.message}</p>
                              )}
                            </div>
                          )}
                        />
                    </div>
                    <div className={classes.input}>
                        <label className="block font-medium">Status</label> <br />
                        <select {...register("status")} className="w-full p-2 border rounded">
                            <option value="">Select Status</option>
                            <option value="ACTIVE">ACTIVE</option>
                            <option value="INACTIVE">INACTIVE</option>
                        </select>
                        <p className={classes.formError}>{errors.status?.message}</p>
                    </div>

                    <button type="submit" className={classes.submitButton}>Submit</button>
                  </>
              </form>
          </div>
        
      </div>
    </>
  );
};
export default AddSong;
